import React, { useRef } from "react";
import useBackInStock from "src/hooks/useBackInStock";
import * as styles from "./styles.mod.scss";
import locale from "locales";
import orange from "assets/images/icons/orange.svg";

const BackInStock = ({ variant }) => {
  const id = atob(variant?.id).replace("gid://shopify/ProductVariant/", "");
  const { handleSubmit, success } = useBackInStock(id, handleFormSubmit);

  const emailInputRef = useRef(null);

  function handleFormSubmit(e) {
    e.preventDefault();
    handleSubmit(e);
  }

  return !success ? (

    <div className={styles.backInStockSnippet}>
      <p className={styles.backInStockMessage}>{locale?.products?.backInStock}</p>
      <form onSubmit={handleFormSubmit} className={styles.form}>
        <input
          type="email"
          name="email"
          required
          placeholder="E-mail"
          ref={emailInputRef}
        />
        <button className={styles.submitCta} type="submit">{locale?.products?.send}</button>
      </form>
    </div>
  ) : (
    <div className={styles.successfullyMessage}><div className={styles.iconText}>
      <div className={styles.imgBox}><img src={orange} alt={locale.altText.orangeTick} /></div>
      <p>{locale.products.backInStockSuccess}</p></div></div>
  );
};


export default BackInStock;